import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const TYP_ICONS = { kredit: '🏦', sparvertrag: '💰', versicherung: '🛡️', abo: '📱', unbekannt: '❓' };
const TYP_FARBEN = { kredit: '#ef4444', sparvertrag: '#10b981', versicherung: '#3b82f6', abo: '#8b5cf6', unbekannt: '#94a3b8' };

export default function KontoauszugPage() {
  const navigate = useNavigate();
  const [datei, setDatei] = useState(null);
  const [laden, setLaden] = useState(false);
  const [ergebnisse, setErgebnisse] = useState(null);
  const [ausgewaehlt, setAusgewaehlt] = useState({});
  const [bestaetigt, setBestaetigt] = useState(false);
  const [fehler, setFehler] = useState('');
  const [speichern, setSpeichern] = useState(false);

  async function analysieren() {
    if (!datei) return;
    setLaden(true); setFehler(''); setErgebnisse(null);
    try {
      const formData = new FormData();
      formData.append('datei', datei);
      const res = await api.post('/kontoauszug/analyse', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 120000
      });
      setErgebnisse(res.data);
      // Alle relevanten Buchungen vorauswählen
      const vorauswahl = {};
      res.data.ergebnisse.forEach((e, i) => {
        // bestaetigen → zuordnen wenn zahlung_id vorhanden, sonst neu_anlegen
        const aktion = e.aktion === 'bestaetigen' ? (e.zahlung_id ? 'zuordnen' : 'neu_anlegen') : (e.aktion || (e.zahlung_id ? 'zuordnen' : 'neu_anlegen'));
        vorauswahl[i] = aktion;
      });
      setAusgewaehlt(vorauswahl);
    } catch(e) {
      setFehler(e.response?.data?.error || 'Fehler bei der Analyse');
    }
    setLaden(false);
  }

  async function bestaetigen() {
    setSpeichern(true);
    try {
      const aktionen = Object.entries(ausgewaehlt)
        .filter(([, aktion]) => aktion !== 'ignorieren')
        .map(([idx, aktion]) => {
          const e = ergebnisse.ergebnisse[parseInt(idx)];
          return { aktion, zahlung_id: e.zahlung_id, vorschlag: e.vorschlag, typ: e.typ };
        });
      await api.post('/kontoauszug/bestaetigen', { aktionen });
      setBestaetigt(true);
    } catch(e) {
      setFehler(e.response?.data?.error || 'Fehler beim Speichern');
    }
    setSpeichern(false);
  }

  if (bestaetigt) return (
    <div style={{ padding: '40px', textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
      <div style={{ fontSize: '64px', marginBottom: '16px' }}>✅</div>
      <h2 style={{ color: '#10b981' }}>Erfolgreich übernommen!</h2>
      <p style={{ color: '#64748b' }}>Die erkannten Zahlungen wurden angelegt bzw. zugeordnet.</p>
      <button onClick={() => navigate('/zahlungen')}
        style={{ marginTop: '24px', padding: '12px 32px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '16px' }}>
        Zu den Zahlungen →
      </button>
    </div>
  );

  return (
    <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
        <button onClick={() => navigate('/zahlungen')} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>←</button>
        <h1 style={{ margin: 0, fontSize: '28px' }}>📄 Kontoauszug analysieren</h1>
      </div>

      {/* Upload Bereich */}
      {!ergebnisse && (
        <div style={{ background: 'white', borderRadius: '16px', padding: '32px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', marginBottom: '24px' }}>
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>📂</div>
            <h2 style={{ margin: '0 0 8px', color: '#1e293b' }}>Kontoauszug hochladen</h2>
            <p style={{ color: '#64748b', margin: 0 }}>CSV oder PDF – Claude KI analysiert automatisch alle Buchungen</p>
          </div>

          <div style={{ border: '2px dashed #e2e8f0', borderRadius: '12px', padding: '32px', textAlign: 'center', background: '#f8fafc' }}>
            <input type="file" accept=".csv,.pdf" onChange={e => setDatei(e.target.files[0])}
              style={{ marginBottom: '16px', width: '100%' }} />
            {datei && (
              <div style={{ color: '#10b981', fontWeight: '600', marginBottom: '16px' }}>
                ✅ {datei.name} ({(datei.size / 1024).toFixed(0)} KB)
              </div>
            )}
          </div>

          {fehler && <div style={{ background: '#fee2e2', color: '#dc2626', padding: '12px', borderRadius: '8px', marginTop: '16px' }}>{fehler}</div>}

          <div style={{ marginTop: '16px', padding: '12px', background: '#f0fdf4', borderRadius: '8px', fontSize: '13px', color: '#15803d' }}>
            💡 Unterstützte Formate: ING, DKB, Comdirect, Sparkasse CSV-Exporte sowie PDF-Kontoauszüge
          </div>

          <button onClick={analysieren} disabled={!datei || laden}
            style={{ width: '100%', marginTop: '20px', padding: '14px', background: laden ? '#94a3b8' : '#6366f1',
              color: 'white', border: 'none', borderRadius: '10px', cursor: laden ? 'not-allowed' : 'pointer',
              fontWeight: '700', fontSize: '16px' }}>
            {laden ? '🤖 Claude analysiert... (kann 30-60 Sek. dauern)' : '🚀 Jetzt analysieren'}
          </button>
        </div>
      )}

      {/* Ergebnisse */}
      {ergebnisse && (
        <>
          <div style={{ background: '#f0fdf4', borderRadius: '12px', padding: '16px 20px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <span style={{ fontWeight: '700', fontSize: '18px', color: '#15803d' }}>
                {ergebnisse.ergebnisse.filter(e => e.typ !== 'unbekannt').length} Zahlungen erkannt
              </span>
              <span style={{ color: '#64748b', marginLeft: '16px', fontSize: '14px' }}>
                von {ergebnisse.analysiert} Buchungen
              </span>
            </div>
            <button onClick={() => { setErgebnisse(null); setDatei(null); }}
              style={{ padding: '8px 16px', background: '#f1f5f9', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
              Neue Datei
            </button>
          </div>

          {/* Statistik nach Typ */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(90px, 1fr))', gap: '10px', marginBottom: '20px' }}>
            {['kredit','sparvertrag','versicherung','abo','unbekannt'].map(typ => {
              const anzahl = ergebnisse.ergebnisse.filter(e => e.typ === typ).length;
              return (
                <div key={typ} style={{ background: 'white', borderRadius: '10px', padding: '12px', textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderTop: `3px solid ${TYP_FARBEN[typ]}` }}>
                  <div style={{ fontSize: '20px' }}>{TYP_ICONS[typ]}</div>
                  <div style={{ fontWeight: '700', fontSize: '18px', color: TYP_FARBEN[typ] }}>{anzahl}</div>
                  <div style={{ fontSize: '11px', color: '#64748b', textTransform: 'capitalize' }}>{typ}</div>
                </div>
              );
            })}
          </div>

          {/* Buchungsliste */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
            {ergebnisse.ergebnisse.map((e, i) => (
              <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '16px 20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderLeft: `4px solid ${TYP_FARBEN[e.typ]}`,
                opacity: ausgewaehlt[i] === 'ignorieren' ? 0.5 : 1 }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                      <span style={{ fontSize: '20px' }}>{TYP_ICONS[e.typ]}</span>
                      <span style={{ fontWeight: '700', fontSize: '16px' }}>{e.vorschlag?.name || e.buchung?.verwendungszweck?.substring(0, 40)}</span>
                      <span style={{ background: TYP_FARBEN[e.typ] + '20', color: TYP_FARBEN[e.typ], padding: '2px 8px', borderRadius: '99px', fontSize: '11px', fontWeight: '600', textTransform: 'capitalize' }}>{e.typ}</span>
                    </div>
                    <div style={{ color: '#64748b', fontSize: '13px', marginBottom: '6px' }}>
                      📅 {e.buchung?.datum} &nbsp;|&nbsp;
                      💶 {e.buchung?.betrag}€ &nbsp;|&nbsp;
                      🏢 {e.vorschlag?.anbieter || e.buchung?.empfaenger || 'k.A.'}
                      {e.vorschlag?.intervall && <>&nbsp;|&nbsp; 🔄 {e.vorschlag.intervall}</>}
                    </div>
                    <div style={{ fontSize: '12px', color: '#94a3b8', fontStyle: 'italic' }}>💬 {e.begruendung}</div>
                    {e.aktion === 'zuordnen' && e.zahlung_id && (
                      <div style={{ fontSize: '12px', color: '#10b981', marginTop: '4px', fontWeight: '600' }}>
                        🔗 Wird bestehender Zahlung zugeordnet (ID: {e.zahlung_id})
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', minWidth: '140px' }}>
                    {['neu_anlegen','zuordnen','ignorieren'].map(aktion => {
                      const labels = { neu_anlegen: '➕ Neu anlegen', zuordnen: '🔗 Zuordnen', ignorieren: '✖ Ignorieren' };
                      const aktionVerfuegbar = aktion !== 'zuordnen' || e.zahlung_id;
                      if (!aktionVerfuegbar) return null;
                      return (
                        <button key={aktion} onClick={() => setAusgewaehlt(prev => ({ ...prev, [i]: aktion }))}
                          style={{ padding: '6px 10px', border: `2px solid ${ausgewaehlt[i] === aktion ? '#6366f1' : '#e2e8f0'}`,
                            borderRadius: '6px', background: ausgewaehlt[i] === aktion ? '#eef2ff' : 'white',
                            cursor: 'pointer', fontWeight: ausgewaehlt[i] === aktion ? '700' : '400',
                            color: ausgewaehlt[i] === aktion ? '#6366f1' : '#374151', fontSize: '12px' }}>
                          {labels[aktion]}
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {fehler && <div style={{ background: '#fee2e2', color: '#dc2626', padding: '12px', borderRadius: '8px', marginBottom: '16px' }}>{fehler}</div>}

          <button onClick={bestaetigen} disabled={speichern || Object.keys(ausgewaehlt).filter(k => ausgewaehlt[k] !== 'ignorieren').length === 0}
            style={{ width: '100%', padding: '16px', background: '#10b981', color: 'white', border: 'none',
              borderRadius: '10px', cursor: 'pointer', fontWeight: '700', fontSize: '16px' }}>
            {speichern ? '💾 Wird gespeichert...' : `✅ ${Object.keys(ausgewaehlt).filter(k => ausgewaehlt[k] !== 'ignorieren').length} Zahlungen übernehmen`}
          </button>
        </>
      )}
    </div>
  );
}
